<template>
  <img :src="src" :srcset="srcset" @load="$emit('image-loaded')" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    /**
     * An array of numbers which represent the width of each image in the srcset
     */
    breakpoints: {
      type: Array,
      default: () => [480, 640, 768, 1024, 1200, 1440, 1920],
    },
    /**
     * An aspect ratio in Width x Height. Used to determine the height of images in the srcset
     */
    aspectRatio: {
      type: String,
      default: undefined,
      validator: (val) => ['1x1', '4x3'].includes(val),
    },
    format: {
      type: String,
      default: 'png',
    },
  },

  computed: {
    heightFromWidthFactor() {
      const aspect = this.aspectRatio?.split('x');
      return this.aspectRatio ? Number(aspect[1]) / Number(aspect[0]) : undefined;
    },
    srcset() {
      const separator = this.src.includes('?') ? '&' : '?';
      const srcset = this.breakpoints.map((width) => {
        const height = this.aspectRatio ? `&hei=${width * this.heightFromWidthFactor}` : '';
        return `${this.src}${separator}fmt=${this.format}&wid=${width}${height} ${width}w`;
      });
      return srcset.join(',');
    },
  },
};
</script>
